import { useEffect } from 'react';

export const useSyncDialogContent = (data, setDialogContent) => {
  useEffect(() => {
    setDialogContent(prev => {
      if (prev?.id) {
        return data?.allBookings?.find(({ id }) => id === prev.id) || {};
      }

      return {};
    });
  }, [data]);
};
